import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";

import { authReducer } from "./reducers/authReducer";
import { userDetailsReducer, userListReducer } from "./reducers/userReducer";
import { liveMonitorReducer } from "./reducers/liveMonitorReducer";
import { deviceSourceListReducer, equipmentDetailsReducer, equipmentListReducer } from "./reducers/equipmentReducer";

const rootReducer = combineReducers({
    auth: authReducer,
    userList: userListReducer,
    userDetails: userDetailsReducer,
    liveMonitor: liveMonitorReducer,

    equipmentList: equipmentListReducer,
    equipmentDetails: equipmentDetailsReducer,
    deviceSourceList: deviceSourceListReducer,
});

const store = createStore(
    rootReducer,
    applyMiddleware(thunk)
);

export default store;